import React from "react";
import { useParams } from "react-router-dom";
import HorizontalLeftButton from "../../../components/HorizontalLeftButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

import { t } from "i18next";
import { Trans } from "react-i18next";
import phShocking from "../../../assets/images/blurred2/imoji/shoking.png";
import phSwag from "../../../assets/images/blurred2/imoji/swag.png";
import phThinking from "../../../assets/images/blurred2/imoji/thinking.png";

const buttonText = [
  t("ai_content_creation.no_news"),
  t("ai_content_creation.curious"),
  t("ai_content_creation.heard_of_it"),
];

const data = [
  {
    image: addS3Url("/imoji/shoking.png"),
    placeHolderImage: phShocking,
  },
  {
    image: addS3Url("/imoji/thinking.png"),
    placeHolderImage: phThinking,
  },
  {
    image: addS3Url("/imoji/swag.png"),
    placeHolderImage: phSwag,
  },
];

const AiTools = () => {
  const params = useParams();
  return (
    <MobileViewLayout>
      <div className="d-flex align-items-center aitools-outer px-4">
        <div>
          <h2 className="fw-bold text-center  m-0 fs30 aitools-header">
            <Trans i18nKey={"ai_content_creation.question"} />
          </h2>
          <div className="w-100  d-flex flex-column gap-1 income-slab-option ">
            {data.map((item, index) => (
              <HorizontalLeftButton
                key={index}
                navigateTo={{
                  pathname: `/${params.gender}/digitalmarketingrating`,
                }}
                label={buttonText[index]}
                className="remote-button-text aiTools-button-text fs18"
                imgClass="button-image"
                {...item}
              />
            ))}
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default AiTools;
